import { useParentNavAlwaysEnabled } from 'hooks/useRbacNavCheck'
import { buildTranslate } from 'locales'
import React from 'react'
import { useAbility } from 'utilities/ability'
import AccordionButton from '../Bar/AccordionButton'
import MenuItem from '../Bar/MenuItem'
import RewardsContent from './Content'

const t = buildTranslate('nav.rewards_menu')

type PropsT = {
  isLeftNav?: boolean
  onClick?: () => void
  paths: string[]
}

const Rewards: React.FC<PropsT> = ({
  isLeftNav = false,
  onClick = () => {},
  paths,
}) => {
  const ability = useAbility()
  const parentAlwaysEnabled = useParentNavAlwaysEnabled()
  const menuDisabled =
    !parentAlwaysEnabled &&
    ability.cannot('access', 'RedeemManager') &&
    ability.cannot('access', 'Billing')

  const Parent = isLeftNav ? AccordionButton : MenuItem

  return (
    <Parent disabled={menuDisabled} paths={paths} buttonContents={t('button')}>
      <RewardsContent isLeftNav={isLeftNav} onClick={onClick} />
    </Parent>
  )
}

export default Rewards
